<template>
  <div class="search-item">
    <!-- WEBSITE -->
    <search-item-web
      :item="item"
      v-if="collection === 'wwf-au-web'"
    ></search-item-web>

    <!-- FAQ -->
    <search-item-faq
      :item="item"
      v-else-if="collection === 'wwf-au-faq'"
    ></search-item-faq>

    <!-- YOUTUBE -->
    <search-item-youtube
      :item="item"
      v-else-if="collection === 'wwf-au-youtube'"
    ></search-item-youtube>

    <!-- INSTAGRAM -->
    <search-item-instagram
      :item="item"
      v-else-if="collection === 'wwf-au-instagram'"
    ></search-item-instagram>
  </div>
</template>

<script>
import SearchItemWeb from "./SearchItemWeb";
import SearchItemFaq from "./SearchItemFaq";
import SearchItemYoutube from "./SearchItemYoutube";
import SearchItemTwitter from "./SearchItemTwitter";
import SearchItemInstagram from "./SearchItemInstagram";

export default {
  name: "SearchItem",
  components: {
    SearchItemWeb,
    SearchItemFaq,
    SearchItemYoutube,
    SearchItemTwitter,
    SearchItemInstagram,
  },
  computed: {
    collection() {
      return this.item.collection;
    },
  },
  props: {
    item: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.search-item {
  border: 1px solid var(--wwfTransparentBlack015);
}

/* Basic style for all types of results */

.search-item >>> .search-item-container {
  display: flex;
  flex-direction: column;
}

.search-item >>> .search-item-header {
  padding: 12px 20px;
  border-bottom: 1px solid var(--wwfTransparentBlack015);
}

.search-item >>> .search-item-title {
  color: var(--wwfOrange);
}

.search-item >>> .search-item-title h4 {
  margin-bottom: 8px;
  font-size: 22px;
  line-height: 31px;
  word-break: break-word;
}

.search-item >>> .search-item-link a {
  color: var(--wwfGrey52);
  font-style: italic;
  font-size: 16px;
  line-height: 26px;
  word-break: break-all;
}

.search-item >>> .search-item-header-date {
  display: none;
}

.search-item >>> .search-item-content {
  padding: 12px 20px;
  word-break: break-word;
}

.search-item >>> .search-item-content img,
.search-item >>> .search-item-content .search-item-image-wrapper {
  display: inline;
  float: right;
  max-height: 90px;
  max-width: 140px;
  margin-left: 1rem;
}

.search-item >>> .search-item-content .search-item-image-wrapper img {
  margin-left: 0;
}

.search-item >>> .search-item-date {
  font-size: 14px;
  color: var(--wwfGrey52);
}

@media only screen and (max-width: 450px) {
  .search-item {
    margin-bottom: 4px;
    border-top: 1px solid var(--wwfOrange);
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  .search-item >>> .search-item-header {
    padding: 12px 4px;
    border-bottom: none;
  }

  .search-item >>> .search-item-title h4 {
    margin-bottom: 0px;
    font-size: 18px;
    line-height: 27px;
  }

  .search-item >>> .search-item-title h4 a {
    color: var(--wwfBlack);
  }

  .search-item >>> .search-item-link {
    display: none;
  }

  .search-item >>> .search-item-header-date {
    display: initial;
    font-size: 14px;
    color: var(--wwfGrey52);
  }

  .search-item >>> .search-item-content {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// SearchItem.vue?44db1286